import { c as _c } from "react/compiler-runtime";
import { twMerge } from 'tailwind-merge';
import { LimitType } from '../../../types/pagination-interface';
import { ACTION_KEY } from '../constants';
import { ColumnDefinitionInterface } from '../types/column-interface';
interface TableSkeletonProps<T> {
  columns: ColumnDefinitionInterface<T>[];
  totalWidth: number;
  limit?: LimitType;
}
export function TableSkeleton(t0) {
  const $ = _c(6);
  const {
    columns,
    totalWidth,
    limit
  } = t0;
  let t1;
  if ($[0] !== limit) {
    t1 = Array.from(Array(limit || 10).keys());
    $[0] = limit;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== columns || $[3] !== t1 || $[4] !== totalWidth) {
    t2 = <>{t1.map((row, index) => <div key={`row-${index}`} className={`even:bg-brand-primary-subtle odd:bg-background-secondary group flex animate-pulse flex-col items-start gap-4 border border-transparent p-4 lg:flex-row lg:items-center lg:gap-0 lg:p-0 ${index === 9 && "rounded-b-lg"}`}>{columns.map((column, index2) => {
          if (!column.widthPercent) {
            column.widthPercent = 25;
          }
          const widthPercent = column.widthPercent || 25;
          const isFirst = index2 === 0;
          const isLast = index2 === columns.length - 1;
          return <div className={twMerge("lg:p-4", column.key === ACTION_KEY ? "w-[42px] lg:w-[82px]" : "w-full", isFirst && "lg:pl-6", isLast && "lg:pr-6", column.className)} key={`cell-${index2}`} style={{
            flex: `${column.key !== ACTION_KEY && `${widthPercent / totalWidth * 100}`}`
          }}><div className="bg-skeleton-primary rounded-sm text-transparent">.</div></div>;
        })}</div>)}</>;
    $[2] = columns;
    $[3] = t1;
    $[4] = totalWidth;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}